import type { CityConfig } from "@/pages/city-template/types";

export const ashevilleConfig: CityConfig = {
  city: "Asheville",
  state: "North Carolina",
  stateAbbr: "NC",
  slug: "asheville",
  route: "/cities/asheville",
  title: "Emergency Passport Asheville, NC — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Asheville, NC — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Buncombe County and the Blue Ridge Mountain region. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Asheville, NC",
  heroSubtitle: "Passport expired before your trip? Need an emergency passport fast? We help Asheville and Blue Ridge Mountain travelers get their expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Beautiful%20panoramic%20view%20of%20Asheville%20North%20Carolina%20with%20the%20Blue%20Ridge%20Mountains%20in%20the%20background%2C%20downtown%20Asheville%20with%20historic%20art%20deco%20buildings%20and%20the%20Biltmore%20Estate%20visible%20in%20the%20distance%2C%20lush%20green%20mountain%20forests%2C%20warm%20golden%20afternoon%20sunlight%2C%20clean%20blue%20sky%20with%20soft%20clouds%2C%20vibrant%20autumn%20foliage%20colors%2C%20professional%20landscape%20and%20cityscape%20photography%2C%20no%20text%20or%20signs%20on%20buildings%2C%20serene%20mountain%20town%20atmosphere&width=1800&height=700&seq=asheville-hero-2026&orientation=landscape",
  heroImageAlt: "Asheville North Carolina with the Blue Ridge Mountains and historic downtown",
  geoPosition: "35.5951;-82.5515",
  geoPlacename: "Asheville, North Carolina",
  lastModified: "2026-06-12",
  regionalAgency: {
    name: "Atlanta Passport Agency",
    address: "230 Peachtree Street NW, Suite 1400, Atlanta, GA 30303",
    distance: "Located in downtown Atlanta — approximately 200 miles from Asheville via I-26",
  },
  nearbyCitiesZips: [
    { name: "Asheville", zips: "28801–28816" },
    { name: "Hendersonville", zips: "28739, 28791, 28792" },
    { name: "Black Mountain", zips: "28711" },
    { name: "Waynesville", zips: "28785, 28786" },
    { name: "Brevard", zips: "28712" },
    { name: "Weaverville", zips: "28787" },
    { name: "Swannanoa", zips: "28778" },
    { name: "Candler", zips: "28715" },
    { name: "Arden", zips: "28704" },
    { name: "Fletcher", zips: "28732" },
    { name: "Mills River", zips: "28759" },
    { name: "Canton", zips: "28716" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent Asheville departures — bypass the 3.5-hour Atlanta drive" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting with reserved agency submission slots" },
    { icon: "ri-map-pin-line", title: "Blue Ridge Mountain Hub", desc: "Serving Buncombe, Henderson, Haywood, and Transylvania counties" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish — no automated systems" },
  ],
  testimonials: [
    {
      name: "Karen L.",
      location: "Asheville, NC",
      rating: 5,
      text: "My passport expired the week before our Biltmore Estate trip to France. Fast Passport Center had my renewal in 4 days. Never had to leave the mountains. Outstanding service.",
      service: "Passport Renewal",
    },
    {
      name: "Mark D.",
      location: "Hendersonville, NC",
      rating: 5,
      text: "Emergency passport for a family medical emergency in Ireland. Got it in 30 hours. The team was incredibly responsive and compassionate. True lifesavers.",
      service: "Emergency Passport",
    },
    {
      name: "Jennifer R.",
      location: "Black Mountain, NC",
      rating: 5,
      text: "Business trip to London came up with 7 days notice. They got me a passport in 4 business days. The communication was outstanding throughout the entire process.",
      service: "Emergency Passport",
    },
    {
      name: "Tom S.",
      location: "Brevard, NC",
      rating: 5,
      text: "First passport for my daughter before her mission trip to Peru. Fast Passport Center helped us navigate every step. Ready in 5 days with zero stress.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "asheville-1",
      name: "Asheville Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "445 Postal Rd",
      city: "Asheville",
      state: "NC",
      zip: "28803",
      phone: "(828) 274-4535",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "South Asheville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Asheville facility. High volume — appointments strongly recommended. Call ahead to confirm passport acceptance hours.",
      icon: "ri-mail-line",
    },
    {
      id: "asheville-2",
      name: "Hendersonville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "825 Spartanburg Hwy",
      city: "Hendersonville",
      state: "NC",
      zip: "28792",
      phone: "(828) 692-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "South Buncombe County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Convenient for Hendersonville and Flat Rock residents. Less crowded than downtown Asheville.",
      icon: "ri-mail-line",
    },
    {
      id: "asheville-3",
      name: "Black Mountain Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "301 E State St",
      city: "Black Mountain",
      state: "NC",
      zip: "28711",
      phone: "(828) 669-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "East Buncombe County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Black Mountain and Swannanoa area. Full passport services. Appointments required.",
      icon: "ri-mail-line",
    },
    {
      id: "asheville-4",
      name: "Waynesville Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "123 S Main St",
      city: "Waynesville",
      state: "NC",
      zip: "28786",
      phone: "(828) 452-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "West Buncombe County, Haywood County",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Haywood County and west Buncombe County. Call for appointment availability.",
      icon: "ri-mail-line",
    },
    {
      id: "asheville-5",
      name: "Buncombe County Clerk of Court",
      type: "Court Clerk Passport Acceptance",
      address: "60 Court Plaza",
      city: "Asheville",
      state: "NC",
      zip: "28801",
      phone: "(828) 259-3400",
      hours: "Mon–Fri: 8:00 AM – 5:00 PM",
      distance: "Buncombe County Courthouse, downtown Asheville",
      website: "https://www.buncombecounty.org/",
      websiteLabel: "Buncombe County Clerk",
      notes: "Accepts passport applications. Good alternative to post office with extended hours. Appointment recommended.",
      icon: "ri-government-line",
    },
    {
      id: "asheville-6",
      name: "Brevard Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "160 S Broad St",
      city: "Brevard",
      state: "NC",
      zip: "28712",
      phone: "(828) 883-2511",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Transylvania County, south of Asheville",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Transylvania County and the Brevard area. Full passport services.",
      icon: "ri-mail-line",
    },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Asheville before international travel?", a: "Yes. Fast Passport Center provides emergency passport services in Asheville for travelers with urgent international flights. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24–48 hour turnaround — without the 3.5 hour drive to Atlanta." },
    { q: "How fast can I renew my passport in Asheville?", a: "Fast Passport Center offers fast passport renewal in Asheville in as little as 24–48 hours through our emergency courier service. For less urgent travel, our 3–5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Asheville?", a: "The nearest regional passport agency to Asheville is the Atlanta Passport Agency, approximately 200 miles away via I-26. For urgent processing without the mountain drive, Fast Passport Center's registered courier service achieves 24–48 hour turnaround from Asheville without any in-person agency visit required." },
    { q: "Can I get a same-day passport appointment near Asheville?", a: "Same-day passport appointments are only available at the Atlanta Regional Passport Agency — approximately 3.5 hours from Asheville — for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24–48 hour emergency courier processing is the fastest guaranteed option for Buncombe County residents." },
    { q: "Do you serve the entire Blue Ridge Mountain region?", a: "Absolutely. Fast Passport Center serves the entire Blue Ridge Mountain region including Asheville, Hendersonville, Black Mountain, Waynesville, Brevard, Weaverville, Swannanoa, Candler, Arden, Fletcher, Mills River, and Canton. Our courier service works seamlessly from any address in Buncombe, Henderson, or Haywood counties." },
    { q: "Can I expedite a child passport in Asheville?", a: "Yes. Fast Passport Center expedites child passports in Asheville for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Buncombe County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Asheville with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24–48 hours." },
    { q: "Do I need to drive to the Atlanta Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "What airport do Asheville travelers use for international flights?", a: "Asheville Regional Airport (AVL) offers convenient domestic connections to major hubs. For international flights, most Asheville travelers connect through Charlotte Douglas (CLT — 125 miles, American Airlines hub) or Atlanta (ATL — 200 miles, Delta hub). Greenville-Spartanburg (GSP) is another option 55 miles south." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Downtown Asheville", address: "91 Tunnel Rd, Asheville, NC 28805", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — South Asheville", address: "1836 Hendersonville Rd, Asheville, NC 28803", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "Walmart Supercenter — Asheville", address: "125 Bleachery Blvd, Asheville, NC 28805", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
    { name: "FedEx Office — Asheville", address: "1378 Hendersonville Rd, Asheville, NC 28803", hours: "Mon–Fri: 7AM–9PM, Sat: 8AM–6PM", website: "https://www.fedex.com/" },
    { name: "CVS Pharmacy — Hendersonville", address: "825 Spartanburg Hwy, Hendersonville, NC 28792", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walgreens — Hendersonville", address: "825 Spartanburg Hwy, Hendersonville, NC 28792", hours: "Mon–Sun: 7AM–11PM", website: "https://www.walgreens.com/" },
    { name: "CVS Pharmacy — Brevard", address: "161 S Broad St, Brevard, NC 28712", hours: "Mon–Sun: 8AM–10PM", website: "https://www.cvs.com/" },
    { name: "Walmart — Waynesville", address: "135 Town Center Loop, Waynesville, NC 28786", hours: "Mon–Sun: 6AM–11PM", website: "https://www.walmart.com/" },
  ],
  dmvLocations: [
    { name: "NC DMV — Asheville", address: "1624 Hendersonville Rd, Asheville, NC 28803", hours: "Mon–Fri: 8AM–5PM", note: "Driver's license and REAL ID services. Appointment recommended.", featured: true },
    { name: "NC DMV — Hendersonville", address: "1800 Four Seasons Blvd, Hendersonville, NC 28792", hours: "Mon–Fri: 8AM–5PM", note: "REAL ID and passport-related ID services. Appointment strongly recommended.", featured: false },
    { name: "NC DMV — Waynesville", address: "1853 Veterans Blvd, Waynesville, NC 28786", hours: "Mon–Fri: 8AM–5PM", note: "Serves Haywood County and west Buncombe County residents. REAL ID available.", featured: false },
    { name: "NC DMV — Brevard", address: "45 E Morgan St, Brevard, NC 28712", hours: "Mon–Fri: 8AM–5PM", note: "Serves Transylvania County. REAL ID available.", featured: true },
  ],
  airports: [
    {
      code: "AVL",
      name: "Asheville Regional Airport",
      distance: "15 miles south of downtown Asheville",
      address: "61 Terminal Dr, Fletcher, NC 28732",
      note: "Primary airport for the Blue Ridge Mountain region. Direct flights to major domestic hubs including Atlanta, Charlotte, and Chicago. Seasonal international connections are limited — most international travel requires a connection.",
      flightUrl: "https://flyavl.com/",
      flightLabel: "AVL Airport",
      featured: true,
    },
    {
      code: "GSP",
      name: "Greenville-Spartanburg International Airport",
      distance: "55 miles south of Asheville",
      address: "2000 GSP Dr, Greer, SC 29651",
      note: "Alternative airport for South Carolina and southern Buncombe County travelers. Additional domestic routes and some seasonal international service.",
      flightUrl: "https://www.gspairport.com/",
      flightLabel: "GSP Airport",
      featured: false,
    },
    {
      code: "CLT",
      name: "Charlotte Douglas International Airport",
      distance: "125 miles east of Asheville",
      address: "5501 Josh Birmingham Pkwy, Charlotte, NC 28208",
      note: "Major international hub. American Airlines hub with direct flights to Europe, Mexico, and the Caribbean. The primary international gateway for most Blue Ridge Mountain travelers.",
      flightUrl: "https://www.cltairport.com/",
      flightLabel: "CLT Airport",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Asheville international flights. Skip the 3.5-hour drive to Atlanta and let our couriers handle the agency submission.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older. Perfect for Asheville's active retiree community and Biltmore Estate visitors planning international trips.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support. Ideal for Blue Ridge Mountain residents who have never traveled internationally before.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation for Asheville and surrounding mountain communities.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support for Blue Ridge Mountain families planning international adventures.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes for Buncombe County residents.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Asheville artists, musicians, and craft brewers attending international festivals and exhibitions while their primary passport is held for visa processing.",
      bullets: ["Frequent traveler solution", "Backup travel document", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a water-damaged or worn passport before your Blue Ridge Mountains departure. Common for outdoor enthusiasts who discover their hiking-worn passport is no longer acceptable.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The wallet-size passport card for land and sea crossings to Canada, Mexico, Bermuda, and the Caribbean. Convenient for Asheville travelers taking cruises from Charleston or driving to Canada through the Blue Ridge Parkway corridor.",
      bullets: ["Wallet-size convenience", "Land and sea crossings", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Asheville photo shops sometimes use generic sizes. Passport photos must be exactly 2×2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Buncombe County acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Asheville applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Buncombe County families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Asheville travelers often assume standard processing will be fine. It takes 8–11 weeks. Start expedited at least 3 weeks before travel. The 3.5-hour drive to Atlanta is not a backup plan.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "02", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Asheville." },
    { number: "03", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "04", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots — bypass the 200-mile Atlanta drive." },
    { number: "05", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Asheville address — trackable every step of the way." },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — 3.5 hour drive to Atlanta", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Mountain Community Knowledge", agency: "No regional understanding", fpc: "Yes — built-in Blue Ridge and WNC expertise" },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Asheville Residents",
    intro: "Asheville's position as a mountain arts destination — surrounded by the Blue Ridge, 200 miles from the nearest passport agency — creates distinct timing challenges for international travelers. Here's what Western North Carolina residents need to know.",
    cards: [
      {
        icon: "ri-flight-takeoff-line",
        title: "Asheville Regional (AVL) — Your Mountain Gateway",
        subtitle: "15 miles south, connections to major international hubs",
        description: "AVL punches above its weight for a regional airport, with direct flights to Atlanta, Charlotte, Chicago, Dallas, and seasonal routes to Florida and the Northeast. For international travel, the typical pattern is: AVL to ATL or CLT, then onward to Europe, Asia, or beyond. The key advantage is AVL's small size — parking is easy, security lines are minimal, and you can arrive 60-75 minutes before departure. The downside: a delayed connection can strand you in Atlanta or Charlotte, so build in buffer time.",
        tip: "When connecting through ATL or CLT internationally, your passport is checked at AVL before your first flight. Make sure your passport is valid and accessible before leaving the mountains — you can't fix passport issues at a connecting hub.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "Charlotte Douglas (CLT) — American Airlines Hub",
        subtitle: "125 miles east, the Southeast's primary international gateway",
        description: "Charlotte Douglas is American Airlines' second-largest hub and the most common international gateway for Western North Carolina travelers. Direct flights serve London, Frankfurt, Munich, Dublin, Paris, Rome, Madrid, Mexico City, and dozens of Caribbean destinations. The 2-hour drive via I-26 and I-85 is manageable, and many Asheville travelers choose CLT over Atlanta for its slightly shorter drive and American Airlines' extensive international network.",
        tip: "Book CLT international flights with at least a 2.5-hour layover if connecting from AVL. A tight connection through Charlotte means your checked bags might not make it if your AVL flight is delayed.",
      },
      {
        icon: "ri-palette-line",
        title: "Arts, Music & Festival Travel",
        subtitle: "Asheville's creative community travels internationally",
        description: "Asheville's renowned arts scene — River Arts District studios, nationally recognized musicians, craft brewers competing internationally, and chefs invited to global food festivals — creates a unique travel pattern. Artists travel to European gallery openings, musicians tour the UK and Scandinavia, brewers attend international beer competitions in Germany and Belgium, and chefs stage at Michelin-starred restaurants in France and Italy. These trips are often confirmed with minimal notice — a last-minute festival invitation or gallery opening — making expedited passport processing essential.",
        tip: "Asheville's creative professionals should maintain current passports at all times. A career-changing opportunity — like an invitation to exhibit at a European biennial — can come with just weeks of notice.",
      },
      {
        icon: "ri-landscape-line",
        title: "Outdoor & Adventure Tourism Travel",
        subtitle: "Blue Ridge hikers, bikers, and climbers going global",
        description: "Asheville's outdoor recreation culture is legendary — and it breeds global adventurers. Hikers who've conquered the Appalachian Trail set their sights on Patagonia or the Alps. Mountain bikers trained on Pisgah's trails head to the Dolomites or New Zealand. Whitewater kayakers take on Nepal and Costa Rica. And a significant retiree population, drawn to Asheville for its quality of life, books international river cruises, European walking tours, and multi-country adventures. These trips require passports, and many first-time international travelers from the Asheville area discover passport requirements at the last minute.",
        tip: "If you're an Asheville outdoor enthusiast planning an international adventure trip — especially to remote destinations — start your passport application at least 12 weeks before departure. Many adventure tour operators require passport copies months in advance.",
      },
    ],
    callout: {
      icon: "ri-goblet-line",
      title: "Craft Beer & Culinary Tourism",
      description: "Asheville's status as 'Beer City USA' — with more breweries per capita than almost any American city — creates significant international travel. Brewers attend the Great British Beer Festival, collaborate with Belgian trappist breweries, and compete at international beer competitions. Meanwhile, Asheville's acclaimed restaurant scene sends chefs to stages in Lyon, Barcelona, and Tokyo. These professional opportunities often arise with limited notice, requiring expedited passport services.",
    },
  },
  destinations: {
    title: "Where Asheville Travelers Go — And Why Passports Get Urgent",
    intro: "Asheville's creative community, outdoor culture, and retiree population shape a distinctive set of international destinations and urgency patterns.",
    stats: [
      { stat: "200 miles", label: "distance to the nearest passport agency in Atlanta — no local agency access" },
      { stat: "35%", label: "of expedited requests are first-time passport applicants — highest rate among NC cities we serve" },
      { stat: "Apr–Sep", label: "peak season when festival season, summer tourism, and outdoor adventure travel collide" },
      { stat: "3.5 Hours", label: "drive time to Atlanta Passport Agency — avoided entirely with courier service" },
    ],
    destinations: [
      { name: "Ireland & UK", context: "Strong Scots-Irish heritage throughout Appalachia. Dublin, Edinburgh, and London for heritage tourism, plus music festivals and pub culture. Asheville's Celtic music scene keeps ties strong.", urgency: "Heritage trips often involve older first-time travelers who have never had passports — longer processing needed", icon: "ri-map-pin-2-line" },
      { name: "Germany & Belgium", context: "Asheville brewers attending international beer competitions, collaborating with European breweries, and participating in Oktoberfest. Direct CLT-Frankfurt and CLT-Munich flights make access easy.", urgency: "Competition dates are fixed — no flexibility on travel dates", icon: "ri-map-pin-2-line" },
      { name: "Italy & France", context: "Food and wine tourism for Asheville's culinary community. Chefs staging at European restaurants, artists exhibiting at galleries, and retirees taking European river cruises.", urgency: "Gallery openings and festival invitations often come with 3-4 weeks notice", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Mexico", context: "Cruise departures from Charleston, Miami, and Fort Lauderdale. Resort vacations and all-inclusive packages popular with Asheville retirees and families.", urgency: "Last-minute cruise deals and all-inclusive packages booked 3-4 weeks out", icon: "ri-map-pin-2-line" },
      { name: "New Zealand & Patagonia", context: "Adventure travel for Asheville's outdoor community. Hiking, mountain biking, and kayaking expeditions. Long-haul trips with significant planning — but passport issues discovered late.", urgency: "Guided expeditions require passport copies 3-6 months in advance", icon: "ri-map-pin-2-line" },
      { name: "Japan & Southeast Asia", context: "Asheville's growing Asian cuisine scene, plus retirees taking extended travel through Thailand, Vietnam, and Japan. Cultural tourism and culinary exploration.", urgency: "Extended multi-country itineraries require careful passport validity planning across multiple entry requirements", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other North Carolina Service Areas",
    crossLinksDesc: "We serve travelers across the Tar Heel State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Charlotte", route: "/cities/charlotte" },
      { name: "Raleigh", route: "/cities/raleigh" },
      { name: "North Carolina Overview", route: "/states/north-carolina" },
    ],
  },
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified North Carolina birth certificates from the NCDHHS Vital Records office in Raleigh. Available by mail, online, or in person. Required for first-time passport applications.",
      url: "https://vitalrecords.nc.gov/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through the North Carolina Department of Health and Human Services Vital Records division. Required for estate and legal matters.",
      url: "https://vitalrecords.nc.gov/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request certified marriage certificates from the Buncombe County Register of Deeds. Marriage licenses are issued by the county where the license was obtained.",
      url: "https://www.buncombecounty.org/governing/depts/register-of-deeds/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Buncombe County Clerk of Superior Court. Required for name change passport corrections after divorce.",
      url: "https://www.nccourts.gov/locations/buncombe-county/buncombe-county-clerk-of-superior-court",
    },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Charlotte, NC", route: "/cities/charlotte" },
    { name: "Fast passport renewal in Raleigh, NC", route: "/cities/raleigh" },
    { name: "Emergency passport help in Greensboro, NC", route: "/cities/greensboro" },
    { name: "Urgent passport services in Winston-Salem, NC", route: "/cities/winston-salem" },
    { name: "Same-day passport help in Wilmington, NC", route: "/cities/wilmington" },
    { name: "Passport courier services in Durham, NC", route: "/cities/durham" },
    { name: "Fast passport renewal in Hendersonville, NC", route: "/cities/hendersonville" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Asheville remotely via secure courier. We do not have a walk-in office in Asheville — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Buncombe County and the Blue Ridge Mountain region travelers without the 200-mile drive to Atlanta.",
  fpcOfficeAddress: "525 N Tryon St., Charlotte, NC 28202",
  fpcOfficeDistance: "Serving all of Buncombe County and the Blue Ridge Mountain region including Henderson and Haywood counties",
  serviceAreaIntro: "From downtown Asheville to the mountain towns of Hendersonville, Black Mountain, and Waynesville, from Brevard to Weaverville and Swannanoa — Fast Passport Center serves the entire Blue Ridge Mountain region. We regularly help travelers from Fletcher, Candler, Arden, and Mills River get their passports fast.",
  nearbyCitiesIntro: "We serve all Asheville neighborhoods and the surrounding Blue Ridge Mountain area including Hendersonville, Black Mountain, Waynesville, Brevard, Weaverville, Swannanoa, Candler, Arden, Fletcher, Mills River, and Canton. If you are anywhere in Buncombe, Henderson, or Haywood counties, we have you covered.",
  howItWorksIntro: "Most Asheville travelers complete everything online and ship documents overnight. No need to drive to Atlanta or wait in line at the regional agency. The 200-mile distance to the nearest passport agency means our courier service saves you an entire day of travel.",
  mistakesIntro: "Asheville travelers often face long drives to the nearest regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Asheville and Blue Ridge Mountain travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Asheville? Here are the most common ones we hear from Buncombe County travelers.",
  statePageRoute: "/states/north-carolina",
  statePageName: "North Carolina",
  dmvWebsite: "https://www.ncdot.gov",
  dmvLabel: "North Carolina DMV — Official Website",
};

export default ashevilleConfig;